<template>
  <!-- must be in sync with modules/baserow_enterprise/components/EnterpriseLogo.vue -->
  <component
    :is="getComponent()"
    v-if="getComponent()"
    :variant="variant"
  ></component>
  <template v-else>
    <div class="logo">
      <img :src="logoSource" v-bind="$attrs" :class="[$attrs.class]" />
    </div>
  </template>
</template>

<script>
import logo from '@baserow/modules/core/static/img/logo.svg?url'
import logoOnly from '@baserow/modules/core/static/img/logoOnly.svg?url'

export default {
  name: 'Logo',
  props: {
    variant: {
      type: String,
      default: 'wordmark',
      validator: (value) => ['wordmark', 'icon'].includes(value),
    },
  },
  computed: {
    logoSource() {
      return this.variant === 'icon' ? logoOnly : logo
    },
  },
  methods: {
    getComponent() {
      return (
        Object.values(this.$registry.getAll('plugin'))
          .filter((plugin) => plugin.getLogoComponent() !== null)
          .sort(
            (p1, p2) => p2.getLogoComponentOrder() - p1.getLogoComponentOrder()
          )
          .map((plugin) => plugin.getLogoComponent())[0] || null
      )
    },
  },
}
</script>
